// @ts-nocheck
import { z } from "zod";
export const endSectionSchema = z.object({ "id": z.string().default("end"), "name": z.string().default("End"), "section_type": z.literal("end").optional() });
